import { CourseRun } from "@/common/courseRun/types";

/**
 * Selects the optimal course run based on the following criteria:
 * 1. End date must be either null or in the future
 * 2. Among qualifying runs, select the one with the oldest start date
 */
export function selectOptimalCourseRun(
  courseRuns?: CourseRun[],
): CourseRun | undefined {
  if (!courseRuns || courseRuns.length === 0) {
    return undefined;
  }

  const now = new Date();

  // Filter course runs that have end date either null or in the future
  const activeCourseRuns = courseRuns.filter((courseRun) => {
    if (!courseRun.end) {
      return true; // No end date means it's always active
    }
    return new Date(courseRun.end) > now; // End date is in the future
  });

  if (activeCourseRuns.length === 0) {
    return undefined;
  }

  // Among the active course runs, find the one with the oldest start date
  return activeCourseRuns.reduce((optimal, current) => {
    // Handle cases where start dates might be null
    if (!current.start && !optimal.start) {
      return optimal; // Keep the first one if both have no start date
    }

    if (!current.start) {
      return optimal;
    }

    if (!optimal.start) {
      return current;
    }

    // Compare start dates - return the one with the earlier (older) start date
    return new Date(current.start) < new Date(optimal.start)
      ? current
      : optimal;
  });
}
